import ChangePassword from "./ChangePassword";
import ProfileEdit from "./ProfileEdit";
import ProfileView from "./ProfileView";
import { useProfileModal } from "./hooks/useProfileModal";

const Profile = () => {
  const { view } = useProfileModal();

  return (
    <>
      {view === "VIEW_PROFILE" && <ProfileView />}
      {view === "EDIT_PROFILE" && <ProfileEdit />}
      {view === "CHANGE_PASSWORD" && <ChangePassword />}
    </>
  );
};

export default Profile;
